import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import { PiWarningOctagon } from "react-icons/pi";
import "../../styles/ConfirmDeleteModal.css";

const ConfirmDeleteModal = ({
  show,
  onClose,
  onConfirm,
  loading = false,
  title = "Are you sure you want to delete this item?",
  description = "This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
  children,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={!loading}
      dialogClassName="confirm_delete_modal"
      autoFocus={false}
      restoreFocus={false}
      enforceFocus={false}
      restoreFocusOptions={{ preventScroll: true }}
    >
      <Modal.Body className="confirm_delete_modal_body">
        <button
          type="button"
          className="confirm_delete_close"
          onClick={onClose}
          disabled={loading}
          aria-label="Close"
        >
          <IoClose />
        </button>

        <div className="confirm_delete_icon_wrap" aria-hidden="true">
          <PiWarningOctagon />
        </div>

        <h3>{title}</h3>
        <p>{description}</p>
        {children}
      </Modal.Body>

      <Modal.Footer className="confirm_delete_modal_footer">
        {cancelText != null && (
          <button
            type="button"
            className="confirm_delete_btn confirm_delete_btn_cancel"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button>
        )}
        <button
          type="button"
          className="confirm_delete_btn confirm_delete_btn_danger"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Deleting..." : confirmText}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
